export const DATA_PANEL_FILTERS = [
  { label: "Actual Facing", short: "AF", displayShort: "AF" },
  { label: "Actual Share - Category", short: "AS-C", displayShort: "%A/Cat" },
  { label: "Actual Share - Planogram", short: "AS-PG", displayShort: "%A/PG" },
  { label: "Actual Share - Subcategory", short: "AS-SC", displayShort: "%A/SbCat" },
  { label: "Arigo Creation Date", short: "ACD", displayShort: "ACD" },
  { label: "Avg Price per Product", short: "APP", displayShort: "Av. P/SKU" },
  { label: "Barcode", short: "BRC", displayShort: "BRC" },
  { label: "Barcode Count", short: "BCC", displayShort: "BCC" },
  { label: "Blocking (POS)", short: "BLK", displayShort: "BLK" },
  { label: "Brand Code", short: "BC", displayShort: "BC" },
  { label: "Brand Name", short: "BN", displayShort: "BN" },
  { label: "Category Code", short: "CC", displayShort: "CC" },
  { label: "Category Name", short: "CN", displayShort: "CN" },
  { label: "Daily Sales Rate - Currency", short: "DSR-C", displayShort: "Av. DS (V)" },
  { label: "Daily Sales Rate - Units", short: "DSR-U", displayShort: "Av. DS (U)" },
  { label: "Department Code", short: "DC", displayShort: "DC" },
  { label: "Department Name", short: "DN", displayShort: "DN" },
  { label: "Hangable", short: "HNG", displayShort: "HNG" },
  { label: "Mandatory", short: "MND", displayShort: "MND" },
  { label: "New Product", short: "NP", displayShort: "NP" },
  { label: "Product Name", short: "PN", displayShort: "PN" },
  { label: "Profit - Currency", short: "P-C", displayShort: "Profit (V)" },
  { label: "Profitability %", short: "P%", displayShort: "Profit (%)" },
  { label: "Recommended Facing", short: "RF", displayShort: "RF" },
  { label: "Sales - Currency", short: "S-C", displayShort: "Sales (V)" },
  { label: "Sales - Units", short: "S-U", displayShort: "Sales (U)" },
  { label: "Sales per Facing", short: "SPF", displayShort: "S(V)/FC" },
  { label: "Sales per Meter", short: "SPM", displayShort: "S(V)/M" },
  { label: "Share of Profit - Currency", short: "SOP-C", displayShort: "SoProfit" },
  { label: "Share of Sales - Currency", short: "SOS-C", displayShort: "SoS-V" },
  { label: "Share of Sales - Units", short: "SOS-U", displayShort: "SoS-U" },
  { label: "Shelf Capacity", short: "SC", displayShort: "Cap." },
  { label: "Store Count with Sales", short: "SCS", displayShort: "#Stores-S" },
  { label: "Subcategory Code", short: "SCC", displayShort: "SCC" },
  { label: "Subcategory Name", short: "SCN", displayShort: "SCN" },
  { label: "Supplier Code", short: "SPC", displayShort: "SPC" },
  { label: "Supplier Name", short: "SPN", displayShort: "SPN" },
  { label: "Total Allocated Width", short: "TAW", displayShort: "T. Wid." },
  { label: "Total Allocated Width x Layers", short: "TAW-L", displayShort: "T. Wd * Ly" },
  { label: "Units per Facing", short: "UPF", displayShort: "S(U)/FC" },
  { label: "Units per Meter", short: "UPM", displayShort: "S(U)/M" },
  { label: "Weighted Share - Category", short: "WS-C", displayShort: "%W/Cat" },
  { label: "Weighted Share - Planogram", short: "WS-PG", displayShort: "%W/PG" },
  { label: "Weighted Share - Subcategory", short: "WS-SC", displayShort: "%W/SbCat" }
];

// Root level data field mappings (from hierarchy root or product root)
const ROOT_DATA_MAPPINGS = {
    'DC': 'departmentCode',
    'DN': 'departmentName', 
    'CC': 'categoryCode',
    'CN': 'categoryName',
    'SCC': 'subcategoryCode', 
    'SCN': 'subcategoryName',
    'BC': 'brandCode',
    'BN': 'brandName',
    'SPC': 'supplierCode',
    'SPN': 'supplierName',
    'BRC': 'barcode',
    'PN': 'name',
    'RF': 'recValue',
    'NP': 'isNewProduct',
    'HNG': 'isHangable',
    'MND': 'isMandatoryProduct',
    'BLK': 'isBlock'
};

// Preplan/normalized data field mappings
const PREPLAN_DATA_MAPPINGS = {
    'ACD': 'arigoCreationDate',
    'WS-PG': 'weightedShareProduct',
    'AS-C': 'allocatedShareCategory',
    'WS-C': 'weightedShareCategory',
    'AS-SC': 'allocatedShareSubcategory',
    'WS-SC': 'weightedShareSubcategory',
    'APP': 'avgPricePerProduct',
    'SCS': 'storeCountWithSales',
    'S-U': 'salesUnits',
    'S-C': 'salesCurrency',
    'P-C': 'profitCurrency',
    'P%': 'profitabilityPercent',
    'DSR-C': 'dailySalesRateCurrency',
    'DSR-U': 'dailySalesRateUnits',
    'BCC': 'barcodeCount'
};

// DataPanel data field mappings
const DATA_PANEL_DATA_MAPPINGS = {
    'TAW': 'totalAllocatedWidth',
    'TAW-L': 'totalAllocatedWidthWithLayers',
    'SC': 'shelfCapacity',
    'SPF': 'salesPerFacing',
    'AF': 'totalFacing',
    'UPF': 'unitsPerFacing',
    'SPM': 'salesPerMeter',
    'UPM': 'unitsPerMeter',
    'SOS-C': 'shareOfSaleCurrency',
    'SOS-U': 'shareOfSaleUnit',
    'SOP-C': 'shareOfSaleProfit',
    'AS-PG': 'actualSharePlanogram',
    'AS-C': 'actualShareCategory',
    'AS-SC': 'actualShareSubCategory',
    'WS-PG': 'weightedSharePlanogram',
    'WS-C': 'weightedShareCategory',
    'WS-SC': 'weightedShareSubCategory'
};

// Tab-specific field mappings based on actual hierarchy data structure
export const TAB_SPECIFIC_MAPPINGS = {
    product: {
        // Available fields in product level data
        'BRC': 'barcode',
        'PN': 'name',
        'DC': 'departmentCode',
        'DN': 'departmentName',
        'CC': 'categoryCode',
        'CN': 'categoryName',
        'SCC': 'subcategoryCode',
        'SCN': 'subcategoryName',
        'SPC': 'supplierCode',
        'SPN': 'supplierName',
        'BC': 'brandCode',
        'BN': 'brandName',
        'ACD': 'arigoCreationDate',
        'RF': 'recValue',
        'AF': 'totalFacing',
        'WS-PG': 'weightedSharePlanogram',
        'WS-SC': 'weightedShareSubCategory',
        'AS-SC': 'actualShareSubCategory',
        'TAW': 'totalAllocatedWidth',
        'TAW-L': 'totalAllocatedWidthWithLayers',
        'SC': 'shelfCapacity',
        'APP': 'avgPricePerProduct',
        'SCS': 'storeCountWithSales',
        'SOS-U': 'shareOfSaleUnit',
        'S-U': 'salesUnits',
        'SOS-C': 'shareOfSaleCurrency',
        'S-C': 'salesCurrency',
        'SOP-C': 'shareOfSaleProfit',
        'P-C': 'profitCurrency',
        'P%': 'profitabilityPercent',
        'DSR-C': 'dailySalesRateCurrency',
        'DSR-U': 'dailySalesRateUnits',
        'SPF': 'salesPerFacing',
        'SPM': 'salesPerMeter',
        'BLK': 'isBlock',
        'NP': 'isNewProduct',
        'HNG': 'isHangable',
        'MND': 'isMandatoryProduct'
    },
    category: {
        // Available fields in category level data
        'CC': 'categoryCode',
        'CN': 'categoryName',
        'BCC': 'barcodeCount',
        'WS-PG': 'weightedSharePlanogram',
        'AS-PG': 'actualSharePlanogram',
        'SC': 'shelfCapacity',
        'APP': 'avgPricePerProduct',
        'TAW': 'totalAllocatedWidth',
        'TAW-L': 'totalAllocatedWidthWithLayers',
        'SOS-U': 'shareOfSaleUnit',
        'S-U': 'salesUnits',
        'SOS-C': 'shareOfSaleCurrency',
        'S-C': 'salesCurrency',
        'SOP-C': 'shareOfSaleProfit',
        'P-C': 'profitCurrency',
        'P%': 'profitabilityPercent',
        'DSR-C': 'dailySalesRateCurrency',
        'DSR-U': 'dailySalesRateUnits',
        'SPF': 'salesPerFacing',
        'SPM': 'salesPerMeter'
    },
    'sub-category': {
        // Available fields in subcategory level data
        'SCC': 'subcategoryCode',
        'SCN': 'subcategoryName',
        'CC': 'categoryCode',
        'CN': 'categoryName',
        'BCC': 'barcodeCount',
        'WS-PG': 'weightedSharePlanogram',
        'AS-PG': 'actualSharePlanogram',
        'WS-C': 'weightedShareCategory',
        'AS-C': 'actualShareCategory',
        'SC': 'shelfCapacity',
        'APP': 'avgPricePerProduct',
        'TAW': 'totalAllocatedWidth',
        'TAW-L': 'totalAllocatedWidthWithLayers',
        'SOS-U': 'shareOfSaleUnit',
        'S-U': 'salesUnits',
        'SOS-C': 'shareOfSaleCurrency',
        'S-C': 'salesCurrency',
        'SOP-C': 'shareOfSaleProfit',
        'P-C': 'profitCurrency',
        'P%': 'profitabilityPercent',
        'DSR-C': 'dailySalesRateCurrency',
        'DSR-U': 'dailySalesRateUnits',
        'SPF': 'salesPerFacing',
        'SPM': 'salesPerMeter'
    },
    supplier: {
        // Available fields in supplier level data
        'SPC': 'supplierCode',
        'SPN': 'supplierName',
        'BCC': 'barcodeCount',
        'WS-PG': 'weightedSharePlanogram',
        'AS-PG': 'actualSharePlanogram',
        'WS-SC': 'weightedShareSubcategory',
        'AS-SC': 'actualShareSubCategory',
        'WS-C': 'weightedShareCategory',
        'AS-C': 'actualShareCategory',
        'SC': 'shelfCapacity',
        'APP': 'avgPricePerProduct',
        'TAW': 'totalAllocatedWidth',
        'TAW-L': 'totalAllocatedWidthWithLayers',
        'SOS-U': 'shareOfSaleUnit',
        'S-U': 'salesUnits',
        'SOS-C': 'shareOfSaleCurrency',
        'S-C': 'salesCurrency',
        'SOP-C': 'shareOfSaleProfit',
        'P-C': 'profitCurrency',
        'P%': 'profitabilityPercent',
        'DSR-C': 'dailySalesRateCurrency',
        'DSR-U': 'dailySalesRateUnits',
        'SPF': 'salesPerFacing',
        'SPM': 'salesPerMeter'
    },
    brand: {
        // Available fields in brand level data
        'BC': 'brandCode',
        'BN': 'brandName',
        'SPC': 'supplierCode',
        'SPN': 'supplierName',
        'BCC': 'barcodeCount',
        'WS-PG': 'weightedSharePlanogram',
        'AS-PG': 'actualSharePlanogram',
        'WS-SC': 'weightedShareSubcategory',
        'AS-SC': 'actualShareSubCategory',
        'WS-C': 'weightedShareCategory',
        'AS-C': 'actualShareCategory',
        'SC': 'shelfCapacity',
        'APP': 'avgPricePerProduct',
        'TAW': 'totalAllocatedWidth',
        'TAW-L': 'totalAllocatedWidthWithLayers',
        'SOS-U': 'shareOfSaleUnit',
        'S-U': 'salesUnits',
        'SOS-C': 'shareOfSaleCurrency',
        'S-C': 'salesCurrency',
        'SOP-C': 'shareOfSaleProfit',
        'P-C': 'profitCurrency',
        'P%': 'profitabilityPercent',
        'DSR-C': 'dailySalesRateCurrency',
        'DSR-U': 'dailySalesRateUnits',
        'SPF': 'salesPerFacing',
        'SPM': 'salesPerMeter'
    }
};

// Combined field mappings for all data panel fields
export const PREPLAN_FIELD_MAPPINGS = {
    ...ROOT_DATA_MAPPINGS,
    ...PREPLAN_DATA_MAPPINGS,
    ...DATA_PANEL_DATA_MAPPINGS
};

// Keys for fields that come from dataPanelData
export const DATA_PANEL_DATA_FIELDS = Object.keys(DATA_PANEL_DATA_MAPPINGS);

// Keys for fields that come from root level data
export const ROOT_DATA_FIELDS = Object.keys(ROOT_DATA_MAPPINGS);

// Fields added by setInitialFilteredList during lambdaData appending that are not needed for API refresh payload
export const DATA_PANEL_ENRICHMENT_FIELDS = [
    'lambdaData', 'normalizedLambdaData',
    'brandLambdaData', 'brandNormalizedLambdaData', 'brandDataPanelData',
    'supplierLambdaData', 'supplierNormalizedLambdaData', 'supplierDataPanelData',
    'categoryLambdaData', 'categoryNormalizedLambdaData', 'categoryDataPanelData',
    'subCategoryLambdaData', 'subCategoryNormalizedLambdaData', 'subCategoryDataPanelData',
    'rec'
];

// Field type categorization for sorting
export const NUMERIC_FIELDS = [
    'WS-PG', 'AS-PG', 'WS-C', 'AS-C', 'WS-SC', 'AS-SC', 'SC', 'APP', 'TAW', 'TAW-L', 'SCS', 'SOS-U', 'S-U', 'SOS-C', 'S-C', 'SOP-C', 'P-C', 'P%',
    'DSR-C', 'DSR-U', 'SPF', 'UPF', 'SPM', 'UPM', 'AF', 'RF', 'BCC'
];

export const TEXT_FIELDS = [
    'DN', 'CN', 'SCN', 'BN', 'SPN', 'PN'
];

export const CODE_FIELDS = [
    'DC', 'CC', 'SCC', 'BC', 'SPC', 'BRC',
];

// Helper function to format numbers with minimal decimal places (max 2 decimals)
const formatNumber = (num, useLocaleString = false) => {
    const numValue = Number(num);
    if (isNaN(numValue)) {
        return num;
    }

    const rounded = Math.round(numValue * 100) / 100;

    if (useLocaleString) {
        // For Excel export with thousand separators
        return rounded.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    } else {
        // For UI display
        if (rounded % 1 === 0) {
            return rounded.toString(); // No decimals for whole numbers
        } else {
            return rounded.toFixed(2).replace(/\.?0+$/, ''); // Max 2 decimals, remove trailing zeros
        }
    }
};

export const BOOLEAN_FIELDS = [
    'NP', 'HNG', 'MND', 'BLK'
];

export const DATE_FIELDS = [
    'ACD'
];

// Fields that should not have sorting enabled
export const NON_SORTABLE_FIELDS = [];

// Tab-specific field configurations
export const TAB_SPECIFIC_FIELDS = {
    product: [
        'BRC', 'PN', 'DC', 'DN', 'CC', 'CN', 'SCC', 'SCN', 'SPC', 'SPN', 'BC', 'BN', 
        'ACD', 'RF', 'AF', 'WS-PG', 'AS-PG', 'WS-SC', 'AS-SC', 'TAW', 'TAW-L', 
        'SC', 'APP', 'SCS', 'SOS-U', 'S-U', 'SOS-C', 'S-C', 
        'SOP-C', 'P-C', 'P%', 'DSR-C', 'DSR-U', 'SPF', 'SPM', 'BLK', 'NP', 'HNG', 'MND'
    ],
    brand: [
        'BC', 'BN', 'SPC', 'SPN', 'BCC', 'WS-PG', 'AS-PG', 'WS-SC', 'AS-SC', 'WS-C', 'AS-C', 
        'SC', 'APP', 'TAW', 'TAW-L', 'SOS-U', 'S-U', 'SOS-C', 'S-C', 
        'SOP-C', 'P-C', 'P%', 'DSR-C', 'DSR-U', 'SPF', 'SPM'
    ],
    supplier: [
        'SPC', 'SPN', 'BCC', 'WS-PG', 'AS-PG', 'WS-SC', 'AS-SC', 'WS-C', 'AS-C', 
        'SC', 'APP', 
        // 'DOS', 
        // 'APU', 
        'TAW', 'TAW-L', 'SOS-U', 'S-U', 'SOS-C', 'S-C', 
        'SOP-C', 'P-C', 'P%', 'DSR-C', 'DSR-U', 'SPF', 'SPM'
    ],
    category: [
        'CC', 'CN', 'BCC', 'WS-PG', 'AS-PG', 
        'SC', 'APP', 'TAW', 'TAW-L', 'SOS-U', 'S-U', 'SOS-C', 'S-C', 
        'SOP-C', 'P-C', 'P%', 'DSR-C', 'DSR-U', 'SPF', 'SPM'
    ],
    'sub-category': [
        'SCC', 'SCN', 'CC', 'CN', 'BCC', 'WS-PG', 'AS-PG', 'WS-C', 'AS-C', 
        'SC', 'APP', 'TAW', 'TAW-L', 'SOS-U', 'S-U', 'SOS-C', 'S-C', 
        'SOP-C', 'P-C', 'P%', 'DSR-C', 'DSR-U', 'SPF', 'SPM'
    ]
};

// Normalized data fields for each tab type
export const NORMALIZED_DATA_FIELDS = {
    product: ['WS-PG', 'WS-SC', 'S-U', 'S-C', 'P-C', 'SPF', 'UPF', 'SPM', 'UPM', 'SOS-U', 'SOS-C', 'SOP-C'],
    brand: ['WS-PG', 'WS-C', 'WS-SC', 'S-U', 'S-C', 'P-C', 'SOS-U', 'SOS-C', 'SOP-C', 'SPF', 'SPM'],
    supplier: ['WS-PG', 'WS-C', 'WS-SC', 'S-U', 'S-C', 'P-C', 'SOS-U', 'SOS-C', 'SOP-C', 'SPF', 'SPM'],
    category: ['WS-PG', 'S-U', 'S-C', 'P-C', 'SOS-U', 'SOS-C', 'SOP-C', 'SPF', 'SPM'],
    'sub-category': ['WS-PG', 'WS-C', 'S-U', 'S-C', 'P-C', 'SOS-U', 'SOS-C', 'SOP-C', 'SPF', 'SPM']
};

// Helper function to get the correct field name based on card type
export const getFieldNameForCardType = (filterShort, cardType) => {
    // First check if there's a tab-specific mapping for this field and card type
    if (TAB_SPECIFIC_MAPPINGS[cardType] && TAB_SPECIFIC_MAPPINGS[cardType][filterShort]) {
        return TAB_SPECIFIC_MAPPINGS[cardType][filterShort];
    }
    
    // Fall back to standard mapping for product tab and other fields
    return PREPLAN_FIELD_MAPPINGS[filterShort];
};

// Function to get available options for a specific tab
export const getTabSpecificOptions = (activeTab) => {
    const tabFields = TAB_SPECIFIC_FIELDS[activeTab] || TAB_SPECIFIC_FIELDS.product;
    
    // Create a map for quick lookup of filter options
    const filterMap = new Map();
    DATA_PANEL_FILTERS.forEach(option => {
        filterMap.set(option.short, option);
    });
    
    // Return options in the order specified by TAB_SPECIFIC_FIELDS
    // This ensures the modal shows options in the correct order
    return tabFields
        .map(fieldShort => filterMap.get(fieldShort))
        .filter(option => option !== undefined); // Remove any undefined options
};

// Helper function to check if a field has normalized data available for a specific tab
export const hasNormalizedData = (filterShort, activeTab) => {
    const normalizedFields = NORMALIZED_DATA_FIELDS[activeTab] || [];
    return normalizedFields.includes(filterShort);
};

// Get Lambda data value for a specific filter column
export const getLambdaDataValue = (filter, { prod, prodBrand, prodSubCat, prodCat, prodSup, cardType, isToggleOn, toSimulateProductonly, isExcelExport = false }) => {

    // Determine which Lambda data to use based on card type and toggle state
    // Only switch to normalized data if this specific field has normalized data available
    const hasNormalizedForThisField = hasNormalizedData(filter.short, cardType);
    const useNormalizedData = isToggleOn && hasNormalizedForThisField;

    let lambdaData = null;
    let fallbackLambdaData = null;

    if (cardType === 'product') {
        lambdaData = useNormalizedData ? prod?.normalizedLambdaData : prod?.lambdaData;
        fallbackLambdaData = prod?.lambdaData; // Always have regular data as fallback
    } else if (cardType === 'brand') {
        lambdaData = useNormalizedData ? {...prodBrand?.brandNormalizedLambdaData, ...prodBrand?.brandDataPanelData?.normalized} : { ...prodBrand?.brandDataPanelData, ...prodBrand?.brandLambdaData};
        fallbackLambdaData = { ...prodBrand?.brandDataPanelData, ...prodBrand?.brandLambdaData};
    } else if (cardType === 'sub-category') {
        lambdaData = useNormalizedData ? {...prodSubCat?.subCategoryNormalizedLambdaData, ...prodSubCat?.subCategoryDataPanelData?.normalized} : { ...prodSubCat?.subCategoryDataPanelData, ...prodSubCat?.subCategoryLambdaData};
        fallbackLambdaData = { ...prodSubCat?.subCategoryDataPanelData, ...prodSubCat?.subCategoryLambdaData};
    } else if (cardType === 'category') {
        lambdaData = useNormalizedData ? {...prodCat?.categoryNormalizedLambdaData, ...prodCat?.categoryDataPanelData?.normalized} : { ...prodCat?.categoryDataPanelData, ...prodCat?.categoryLambdaData};
        fallbackLambdaData = { ...prodCat?.categoryDataPanelData, ...prodCat?.categoryLambdaData};
    } else if (cardType === 'supplier') {
        lambdaData = useNormalizedData ? {...prodSup?.supplierNormalizedLambdaData, ...prodSup?.supplierDataPanelData?.normalized} : { ...prodSup?.supplierDataPanelData, ...prodSup?.supplierLambdaData};
        fallbackLambdaData = { ...prodSup?.supplierDataPanelData, ...prodSup?.supplierLambdaData};
    }

    // If preferred lambda data doesn't exist, fallback to regular data
    if (!lambdaData && fallbackLambdaData) {
        lambdaData = fallbackLambdaData;
    }

    // Check if Lambda data exists
    if (!lambdaData) {
        return '-'; // Default value if no Lambda data
    }

    // Frontend handling for TAW-L (Total Allocated Width x Layers)
    // if (filter.short === 'TAW-L') {
    //     let totalTawValue = 0;
    //     let totalStackCount = 0;

    //     if (cardType === 'product') {
    //         // For individual products
    //         totalTawValue = prod?.dataPanelData?.totalAllocatedWidth || 0;
    //         const productStack = prod?.stackCount || 0;
    //         totalStackCount = productStack + 1; // Apply +1 to individual product
    //     } else {
    //         // For hierarchy levels, aggregate from all products in toSimulateProductonly

    //         if (toSimulateProductonly && Array.isArray(toSimulateProductonly)) {
    //             toSimulateProductonly.forEach(product => {
    //                 let shouldInclude = false;

    //                 // Check if this product belongs to the current hierarchy item
    //                 if (cardType === 'category') {
    //                     shouldInclude = product?.categoryId === prodCat?.categoryId ||
    //                         product?.category?.id === prodCat?.categoryId ||
    //                         product?.categoryName === prodCat?.categoryName;
    //                 } else if (cardType === 'sub-category') {
    //                     shouldInclude = product?.subCat?.subCategoryid === prodSubCat?.subCat?.subCategoryid ||
    //                         product?.subcategory?.sub_category?.subCategoryId === prodSubCat?.subCat?.subCategoryid;
    //                 } else if (cardType === 'brand') {
    //                     shouldInclude = (product?.brand?.brandid === prodBrand?.brand?.brandid ||
    //                         product?.brand?.brand?.id === prodBrand?.brand?.brandid ||
    //                         product?.productBrand?.brandId === prodBrand?.brand?.brandid) &&
    //                         (product?.subCat?.subCategoryid === prodBrand?.subCat?.subCategoryid ||
    //                             product?.subcategory?.sub_category?.subCategoryId === prodBrand?.subCat?.subCategoryid);
    //                 } else if (cardType === 'supplier') {
    //                     shouldInclude = product?.supplier?.supplierId === prodSup?.supplier?.supplierId ||
    //                         product?.brand?.brand?.supplier?.supplierId === prodSup?.supplier?.supplierId;
    //                 }

    //                 if (shouldInclude) {
    //                     const productTaw = product?.dataPanelData?.totalAllocatedWidth || 0;
    //                     const productStack = product?.stackCount || 0;
    //                     totalTawValue += productTaw;
    //                     totalStackCount += (productStack + 1); // Apply +1 to each product's stackCount
    //                 }
    //             });
    //         }
    //     }

    //     if (totalTawValue > 0) {
    //         const tawLayers = totalTawValue * totalStackCount;
    //         return formatNumber(tawLayers);
    //     } else {
    //         return '-';
    //     }
    // }


    // Use dynamic field mappings based on card type (for all other filters)
    const fieldName = getFieldNameForCardType(filter.short, cardType);
    if (!fieldName) {
        return '-'; // Default if field not found
    }

    let value = null;

    // Helper function to check if value is valid (not null, undefined, or empty string)
    const isValidValue = (val) => val !== null && val !== undefined && val !== '';

    // Check if this is a boolean field for products (isHangable, isMandatoryProduct, isNewProduct, isBlock)
    // These fields may exist at root level, in lambdaData, or in prePlanData with different naming conventions
    if (cardType === 'product' && BOOLEAN_FIELDS.includes(filter.short)) {
        let boolValue = null;

        // Check multiple possible locations for boolean fields
        if (filter.short === 'NP') {
            // isNewProduct can be: prod.isNewProduct, prod.isNew, lambdaData.isNewProduct, prePlanData.isNewProduct
            boolValue = prod?.isNewProduct ?? prod?.isNew ?? lambdaData?.isNewProduct ?? prod?.prePlanData?.isNewProduct;
        } else if (filter.short === 'HNG') {
            // isHangable can be: prod.isHangable, lambdaData.isHangable, prePlanData.hangable
            boolValue = prod?.isHangable ?? lambdaData?.isHangable ?? prod?.prePlanData?.hangable;
        } else if (filter.short === 'MND') {
            // isMandatoryProduct can be: prod.isMandatoryProduct, prod.isMandatory, lambdaData.isMandatoryProduct
            boolValue = prod?.isMandatoryProduct ?? prod?.isMandatory ?? lambdaData?.isMandatoryProduct ?? prod?.prePlanData?.isMandatoryProduct ?? prod?.prePlanData?.mandatory;
        } else if (filter.short === 'BLK') {
            // isBlock can be: prod.isBlock, prod.isBlocked, lambdaData.isBlock
            boolValue = prod?.isBlock ?? prod?.isBlocked ?? lambdaData?.isBlock;
        }

        if (boolValue === null || boolValue === undefined || boolValue === '') {
            return '-';
        }
        if (typeof boolValue === 'boolean') {
            return boolValue ? 'Yes' : 'No';
        }
        return boolValue;
    }

    // Check if it's a dataPanelData field - respect normalize toggle
    if (DATA_PANEL_DATA_FIELDS.includes(filter.short)) {
        if (isToggleOn && hasNormalizedForThisField) {
            // When toggle is ON, check if field exists in normalizedData first
            let normalizedData = null;
            let fallbackDataPanelData = null;

            if (cardType === 'product') {
                normalizedData = prod?.normalizedLambdaData;
                fallbackDataPanelData = prod?.dataPanelData;
            } else if (cardType === 'brand') {
                normalizedData = prodBrand?.brandDataPanelData?.normalized;
                fallbackDataPanelData = prodBrand?.brandDataPanelData;
            } else if (cardType === 'sub-category') {
                normalizedData = prodSubCat?.subCategoryDataPanelData?.normalized;
                fallbackDataPanelData = prodSubCat?.subCategoryDataPanelData;
            } else if (cardType === 'category') {
                normalizedData = prodCat?.categoryDataPanelData?.normalized;
                fallbackDataPanelData = prodCat?.categoryDataPanelData;
            } else if (cardType === 'supplier') {
                normalizedData = prodSup?.supplierDataPanelData?.normalized;
                fallbackDataPanelData = prodSup?.supplierDataPanelData;
            }

            if (normalizedData && normalizedData.hasOwnProperty(fieldName) && isValidValue(normalizedData[fieldName])) {
                value = normalizedData[fieldName];
            } else {
                // Fallback to regular dataPanelData if normalized value doesn't exist or is invalid
                if (fallbackDataPanelData && fallbackDataPanelData.hasOwnProperty(fieldName)) {
                    value = fallbackDataPanelData[fieldName];
                } else {
                    return '-'; // Default if no data found
                }
            }
        } else {
            // When toggle is OFF or not on products tab, use dataPanelData
            let dataPanelData = null;
            if (cardType === 'product') {
              const specificFieldsFromPrePlan = [
                'weightedSharePlanogram',
                'weightedShareSubCategory',
              ]

              if (specificFieldsFromPrePlan.includes(fieldName)) {
                dataPanelData = {
                  weightedSharePlanogram: prod?.prePlanData?.weightedSharePlanogram,
                  weightedShareSubCategory:
                    prod?.prePlanData?.weightedShareSubcategory,
                }
              } else {
                // Get all other fields from dataPanelData
                dataPanelData = prod?.dataPanelData
              }
            } else if (cardType === 'brand') {
              dataPanelData = prodBrand?.brandDataPanelData
            } else if (cardType === 'sub-category') {
              dataPanelData = prodSubCat?.subCategoryDataPanelData
            } else if (cardType === 'category') {
              dataPanelData = prodCat?.categoryDataPanelData
            } else if (cardType === 'supplier') {
              dataPanelData = prodSup?.supplierDataPanelData
            }

            if (dataPanelData && dataPanelData.hasOwnProperty(fieldName)) {
                value = dataPanelData[fieldName];
            } else {
                return '-'; // Default if dataPanelData field not found
            }
        }
    } else {
        // Check if it's a Lambda data field (preplan/normalized/root level)
        if (isToggleOn && hasNormalizedForThisField) {
            // When toggle is ON and field has normalized data available, try normalized first
            let normalizedData = null;

            if (cardType === 'product') {
                normalizedData = prod?.normalizedLambdaData;
            } else if (cardType === 'brand') {
                normalizedData = {...prodBrand?.brandDataPanelData?.normalized, ...prodBrand?.brandNormalizedLambdaData};
            } else if (cardType === 'sub-category') {
                normalizedData = {...prodSubCat?.subCategoryDataPanelData?.normalized, ...prodSubCat?.subCategoryNormalizedLambdaData};
            } else if (cardType === 'category') {
                normalizedData = {...prodCat?.categoryDataPanelData?.normalized, ...prodCat?.categoryNormalizedLambdaData};
            } else if (cardType === 'supplier') {
                normalizedData = {...prodSup?.supplierDataPanelData?.normalized, ...prodSup?.supplierNormalizedLambdaData};
            }

            if (normalizedData && normalizedData.hasOwnProperty(fieldName) && isValidValue(normalizedData[fieldName])) {
                value = normalizedData[fieldName];
            } else {
                // Fallback to regular lambda data if normalized value doesn't exist or is invalid
                if (lambdaData && lambdaData.hasOwnProperty(fieldName)) {
                    value = lambdaData[fieldName];
                } else {
                    return '-'; // Default if no data found
                }
            }
        } else if (lambdaData && lambdaData.hasOwnProperty(fieldName)) {
            value = lambdaData[fieldName];
        } else {
            return '-'; // Default if field not found
        }
    }

    // Format the value based on type
    if (value === null || value === undefined || value === '') {
        return '-';
    }

    // Format date field, numbers, and booleans
    if (fieldName === 'arigoCreationDate') {
        const date = new Date(value);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' });
    } else if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    } else if (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value)) && value.trim() !== '')) {
        // Convert string numbers to actual numbers for formatting
        const numericValue = typeof value === 'string' ? Number(value) : value;
        value = numericValue;
        // Don't format codes, IDs
        const codeFields = ['departmentCode', 'categoryPosCode', 'subCategoryId', 'brandPosCode', 'brandId',
            'supplierPosCode', 'supplierId', 'barcode', 'barcodeCount', 'subBrandCode'];

        // Integer fields without decimals
        const integerFields = ['recommendedFacing', 'actualFacing', 'totalFacing', 'shelfCapacity', 'storeCountWithSales'];

        // Percentage fields
        const percentageFields = ['weightedSharePlanogram', 'actualSharePlanogram', 'weightedShareCategory',
            'actualShareCategory', 'weightedShareSubCategory', 'actualShareSubCategory',
            'shareOfSaleUnit', 'shareOfSaleCurrency', 'shareOfSaleProfit', 'profitabilityPercent'];

        // Currency fields in thousands
        const currencyKFields = ['salesCurrency', 'profitCurrency'];

        // Rate fields with specific suffixes
        const dailyRateFields = ['dailySalesRateCurrency', 'dailySalesRateUnits'];
        const perFacingFields = ['salesPerFacing', 'unitsPerFacing'];
        const perMeterFields = ['salesPerMeter', 'unitsPerMeter'];

        // Large number fields with commas
        const largeNumberFields = ['salesUnits'];

        if (codeFields.includes(fieldName)) {
            return value.toString();
        } else if (integerFields.includes(fieldName)) {
            return value.toLocaleString();
        } else if (percentageFields.includes(fieldName)) {
            return isExcelExport ? formatNumber(value, true) : formatNumber(value) + '%';
        } else if (currencyKFields.includes(fieldName)) {
            if (isExcelExport) {
                return formatNumber(value, true);
            } else {
                const numValue = Number(value);
                if (numValue >= 1000) {
                    const kValue = numValue / 1000;
                    if (kValue % 1 === 0) {
                        return `${kValue}K`;
                    } else {
                        return `${kValue.toFixed(2).replace(/\.?0+$/, '')}K`;
                    }
                } else {
                    return formatNumber(numValue);
                }
            }
        } else if (dailyRateFields.includes(fieldName)) {
            if (isExcelExport) {
                return formatNumber(value, true);
            } else {
                const numValue = Number(value);
                let formattedValue;
                if (numValue >= 1000) {
                    const kValue = numValue / 1000;
                    formattedValue = kValue % 1 === 0
                        ? `${kValue}K`
                        : `${kValue.toFixed(2).replace(/\.?0+$/, '')}K`;
                } else {
                    formattedValue = formatNumber(numValue);
                }

                if (fieldName === 'dailySalesRateCurrency') {
                    return formattedValue + '/DAY';
                } else {
                    return formattedValue + '/DAY';
                }
            }
        } else if (perFacingFields.includes(fieldName)) {
            if (isExcelExport) {
                return formatNumber(value, true);
            } else {
                const numValue = Number(value);
                let formattedValue;
                if (numValue >= 1000) {
                    const kValue = numValue / 1000;
                    formattedValue = kValue % 1 === 0
                        ? `${kValue}K`
                        : `${kValue.toFixed(2).replace(/\.?0+$/, '')}K`;
                } else {
                    formattedValue = formatNumber(numValue);
                }

                if (fieldName === 'salesPerFacing') {
                    return formattedValue + '/FACE';
                } else {
                    return formattedValue + '/FACE';
                }
            }
        } else if (perMeterFields.includes(fieldName)) {
            if (isExcelExport) {
                return formatNumber(value, true);
            } else {
                const numValue = Number(value);
                let formattedValue;
                if (numValue >= 1000) {
                    const kValue = numValue / 1000;
                    formattedValue = kValue % 1 === 0
                        ? `${kValue}K`
                        : `${kValue.toFixed(2).replace(/\.?0+$/, '')}K`;
                } else {
                    formattedValue = formatNumber(numValue);
                }

                if (fieldName === 'salesPerMeter') {
                    return formattedValue + '/METER';
                } else {
                    return formattedValue + '/METER';
                }
            }
        } else if (largeNumberFields.includes(fieldName)) {
            if (isExcelExport) {
                return formatNumber(value, true);
            } else {
                const numValue = Number(value);
                if (numValue >= 1000) {
                    const kValue = numValue / 1000;
                    if (kValue % 1 === 0) {
                        return `${kValue}K`;
                    } else {
                        return `${kValue.toFixed(2).replace(/\.?0+$/, '')}K`;
                    }
                } else {
                    return numValue.toLocaleString();
                }
            }
        } else {
            return formatNumber(value);
        }
    } else {
        return value;
    }
}